// Pearson correlation coefficient between two numeric columns.

export function computeCorrelation(data, { columnX, columnY } = {}) {

  if (!Array.isArray(data) || !data.length) {
    return { success: false, error: "No data available for correlation." };
  }

  if (!columnX || !columnY) {
    return { success: false, error: "correlation requires two columns." };
  }

  const pairs = data
    .map(r => [Number(r[columnX]), Number(r[columnY])])
    .filter(([x, y]) => !isNaN(x) && !isNaN(y));

  const n = pairs.length;

  if (n < 3) {
    return { success: false, error: "Not enough numeric data points to compute correlation." };
  }

  const xs = pairs.map(p => p[0]);
  const ys = pairs.map(p => p[1]);

  const meanX = xs.reduce((a, b) => a + b, 0) / n;
  const meanY = ys.reduce((a, b) => a + b, 0) / n;

  let numerator = 0;
  let sumSqX = 0;
  let sumSqY = 0;

  for (let i = 0; i < n; i++) {
    const dx = xs[i] - meanX;
    const dy = ys[i] - meanY;
    numerator += dx * dy;
    sumSqX += dx * dx;
    sumSqY += dy * dy;
  }

  const denominator = Math.sqrt(sumSqX * sumSqY);

  const coefficient = denominator === 0 ? 0 : numerator / denominator;

  const abs = Math.abs(coefficient);

  const strength =
    abs >= 0.7 ? "strong" :
    abs >= 0.4 ? "moderate" :
    abs >= 0.2 ? "weak" : "negligible";

  const direction = coefficient > 0 ? "positive" : coefficient < 0 ? "negative" : "none";

  return {
    success: true,
    tool: "correlation",
    columnX,
    columnY,
    coefficient: Math.round(coefficient * 1000) / 1000,
    strength,
    direction,
    sampleSize: n,
  };
}
